import { GenericStatus } from "./props";

const VesselRequisitionItemStatus: GenericStatus[] = [
    {key: "requested", text: "Requested", tagVariant: 'primary'},
    {key: "item_approved", text: "Approved", tagVariant: 'active'},
    {key: "item_rejected", text: "Rejected", tagVariant: 'error'},
    {key: "completed", text: "Completed", tagVariant: 'success'}
]                                                        

export default VesselRequisitionItemStatus;